import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('providers', storeModule.createStoreModule('providers'))
